import { render, staticRenderFns } from "./dialogApprovalRequest.vue?vue&type=template&id=b25cb10e&scoped=true&lang=pug&"
import script from "./dialogApprovalRequest.vue?vue&type=script&lang=js&"
export * from "./dialogApprovalRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b25cb10e",
  null
  
)

export default component.exports